// ./src/components/generic/LoadingIndicator/LoadingIndicator.tsx
import React from "react";
import { Loader, MantineSize, MantineColor } from "@mantine/core";

export interface LoadingIndicatorProps {
  /** Size of the loading indicator */
  size?: MantineSize | number;

  /** Color of the loading indicator (theme color) */
  color?: MantineColor;

  /** Additional className for styling */
  className?: string;

  /** Additional styles */
  style?: React.CSSProperties;

  /** Type of loader */
  type?: "oval" | "bars" | "dots";
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  size = "md",
  color = "blue",
  className,
  style,
  type = "oval",
}) => {
  return (
    <Loader
      size={size}
      color={color}
      type={type}
      {...(className && { className })}
      {...(style && { style })}
    />
  );
};
